import { useState } from "react";
import { Card } from "@/components/ui/card";
import { PaymentDetailsDialog } from "./PaymentDetailsDialog";
import { Eye, CreditCard, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PaymentMethod } from "@/types/payment";

interface PaymentMethodCardProps {
  id: string;
  paymentType: "credit" | "bank";
  lastFour: string | null;
  bankLastFour: string | null;
  cardExpiry?: string | null;
  cardCvv?: string | null;
  cardNumber?: string | null;
}

export const PaymentMethodCard = ({
  id,
  paymentType,
  lastFour,
  bankLastFour,
  cardExpiry,
  cardCvv,
  cardNumber,
}: PaymentMethodCardProps) => {
  const [showDetails, setShowDetails] = useState(false);

  const handleViewDetails = () => {
    console.log("Opening payment details dialog with data:", {
      paymentType,
      lastFour,
      bankLastFour,
      cardExpiry,
      cardNumber
    });
    setShowDetails(true);
  };

  return (
    <>
      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            {paymentType === "credit" ? (
              <CreditCard className="h-6 w-6 text-gray-500" />
            ) : (
              <Building2 className="h-6 w-6 text-gray-500" />
            )}
            <div>
              <p className="font-medium">
                {paymentType === "credit"
                  ? `Card ending in ${lastFour}`
                  : `Account ending in ${bankLastFour}`}
              </p>
              {cardExpiry && (
                <p className="text-sm text-gray-500">Expires: {cardExpiry}</p>
              )}
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleViewDetails}
          >
            <Eye className="h-4 w-4 mr-2" />
            View Details
          </Button>
        </div>
      </Card>

      <PaymentDetailsDialog
        isOpen={showDetails}
        onClose={() => setShowDetails(false)}
        paymentType={paymentType}
        lastFour={lastFour}
        bankLastFour={bankLastFour}
        cardExpiry={cardExpiry}
        cardCvv={cardCvv}
        fullCardNumber={cardNumber}
      />
    </>
  );
};